import { classNamePrefix as prefixCt } from "@/utils/common";
import "./index.less";

export default class orderedListRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("ordered-list")}`;
    this.config = config;
  }
}
